<template>
  <div class="text-center">
    <animation-check />
    <p class="c-primary fs-38 fw-600 mt-4">
      {{ $l.detectLanguage('scanAtPoli') }}
      <span class="c-pink-dokter fw-700">{{ $l.detectLanguage('poliklinikTujuan') }}</span>
    </p>
    <p class="fs-38 fw-600 mt-5 c-primary mb-0">{{ $l.detectLanguage('Nomor Tiket') }}</p>
    <p class="fs-72 fw-700 c-pink-dokter mb-0">{{nomorTicket}}</p>
    <div
      class="row text-left c-pink-dokter list-dokter-antrian w-100"
    >
      <div class="col-12 padding-dokter-select">
        <p class="fs-32 fw-700 c-primary mb-2 text-center">
          {{ $l.detectLanguage('yourApptText') }}
        </p>
        <template v-for="item, index in dokter" :key="index">
          <card-dokter-appointment :class-border="index < dokter.length - 1" :detail-dokter="mapDokter(item)"/>
        </template>
      </div>
    </div>
    <button-time-out :time="timeOut" @click="goToRoute()" class="fs-32 width-200"/>
  </div>
</template>

<script>
import AnimationCheck from '@/components/Button/AnimationCheck.vue'
import ButtonTimeOut from '@/components/Button/ButtonTimeOut.vue'
import CardDokterAppointment from './CardDokterAppointment.vue'
import KioskAntrianMapper from '@/mappers/KioskAntrianMapper'

export default {
  components: {
    AnimationCheck,
    ButtonTimeOut,
    CardDokterAppointment
  },
  props: {
    timeOut: {
      type: Number,
      default: 10
    },
    nomorTicket: {
      type: String,
      default: ''
    },
    dokter: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    mapDokter (item) {
      return KioskAntrianMapper.mapDokterCheckBox(item)
    },
    goToRoute () {
      window.machineKiosk.send({
        type: 'button:ok'
      })
    }
  }
}
</script>

<style>

</style>
